
import React from 'react';
import GeniusCardUpsellHero from '@/components/genius-card-upsell/GeniusCardUpsellHero';
import CongratulationsProblemSection from '@/components/genius-card-upsell/CongratulationsProblemSection';
import TheWallSection from '@/components/genius-card-upsell/TheWallSection';
import SolutionIntroSection from '@/components/genius-card-upsell/SolutionIntroSection';
import TimeEffortComparisonSection from '@/components/genius-card-upsell/TimeEffortComparisonSection';
import ProfessionalPositioningSection from '@/components/genius-card-upsell/ProfessionalPositioningSection';
import ObjectionHandlingSection from '@/components/genius-card-upsell/ObjectionHandlingSection';

const GeniusCardUpsell = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <main className="flex-grow">
        <GeniusCardUpsellHero />
        <CongratulationsProblemSection />
        <TheWallSection />
        <SolutionIntroSection />
        <TimeEffortComparisonSection />
        <ProfessionalPositioningSection />
        <ObjectionHandlingSection />
      </main>
    </div>
  );
};

export default GeniusCardUpsell;
